<ng-container *ngIf="asset.status !== Status.Draft && screenSizeDetectorService.isLargeScreen">
  <button mat-menu-item (click)="editAssets('metaData')" *ngIf="AnyAsset | can: 'update'">
    <mat-icon class="material-icons-outlined">edit</mat-icon>
    <span i18n>Edit metadata</span>
  </button>
  <button mat-menu-item (click)="editAssets('usageRights')" *ngIf="AnyAsset | can: 'usagerights'">
    <mat-icon class="material-icons-outlined">edit</mat-icon>
    <span i18n>Edit usage rights</span>
  </button>
  <button mat-menu-item (click)="editAssets('relations')" *ngIf="AnyAsset | can: 'relations'">
    <mat-icon class="material-icons-outlined">edit</mat-icon>
    <span i18n>Edit relations</span>
  </button>
</ng-container>

<ng-container *ngIf="!collectionFlag && asset.status === Status.Draft && screenSizeDetectorService.isLargeScreen">
  <button mat-menu-item (click)="updateDraftAsset()" *ngIf="AnyAsset | can: 'update'">
    <mat-icon class="material-icons-outlined">edit</mat-icon>
    <span i18n>Edit Asset</span>
  </button>
</ng-container>

<button
  *ngIf="
    asset.status !== Status.Draft &&
    (AccessAsset(asset) | can: 'download') &&
    ((asset.expiryDate | dateNotExpired) || (AccessAsset(asset) | can: 'expired.download')) &&
    (!configObject || !configObject?.hideDownload)
  "
  mat-menu-item
  (click)="downloadAsset.emit()"
>
  <mat-icon class="material-icons-outlined">file_download</mat-icon>
  <span i18n>Download asset</span>
</button>
<button *ngIf="asset.status !== Status.Draft && (AccessAsset(asset) | can: 'share') && (!configObject || !configObject?.hideShare)" mat-menu-item (click)="shareAsset()">
  <mat-icon class="material-icons-outlined">share</mat-icon>
  <span i18n>Share asset</span>
</button>

<ng-container *ngIf="screenSizeDetectorService.isLargeScreen">
  <button *ngIf="asset.status !== Status.Draft && (AnyAsset | can: 'collection.create') && (!configObject || !configObject?.hideAddToCollection)" mat-menu-item (click)="addToCollection()">
    <mat-icon class="material-icons-outlined">perm_media</mat-icon>
    <span i18n>Add to collection</span>
  </button>
  <span class="cursor-pointer">
    <button
      *ngIf="configObject?.callFrom === 'collection' && collectionOwner"
      mat-menu-item
      type="button"
      i18n-matTooltip
      matTooltip="Remove from collection"
      (click)="removeFromCollection(asset['_id'], assetIndex.toString())"
    >
      <mat-icon>
        <span class="material-icons-outlined">{{ [CustomClients.Vorwerk].includes(brandingKey) ? 'gallery_off' : 'folder_off' }}</span>
      </mat-icon>
      <span i18n>Remove from collection</span>
    </button>
  </span>
  <button *ngIf="asset.status !== Status.Draft && false" mat-menu-item (click)="exportAsset.emit()">
    <mat-icon class="material-icons-outlined">add_box</mat-icon>
    <span>Export asset</span>
  </button>
  <button *ngIf="(AccessAsset(asset) | can: 'delete') && (!configObject || !configObject?.hideDelete)" mat-menu-item (click)="deleteAsset.emit({ planDeletionFlag: false })">
    <mat-icon class="material-icons-outlined">delete_outline</mat-icon>
    <span i18n>Delete asset</span>
  </button>
  <button
    *ngIf="asset.status !== Status.Draft && (AccessAsset(asset) | can: 'plandeletion') && (!configObject || !configObject?.hideDelete)"
    mat-menu-item
    (click)="deleteAsset.emit({ planDeletionFlag: true })"
  >
    <mat-icon class="material-icons-outlined">delete_outline</mat-icon>
    <span i18n>Plan deletion</span>
  </button>
</ng-container>
